import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	ButtonIconComponent,
	InfoGroupComponent,
	LinkComponent,
} from '@tecalisdev/infinity';

export type MapDeviceLockMode = 'block' | 'unlock';

export interface IMapDeviceInfoRow {
	/** Prefijo en negrita (Navegador, IP, Fecha). */
	prefix: string;
	value: string;
	/**
	 * Candado IP (mismo criterio que la lista):
	 * `block` → icon-lock + Bloquear; `unlock` → icon-unlock + Desbloquear.
	 */
	lockMode?: MapDeviceLockMode | null;
}

/**
 * InfoWindow del mapa (NIF-353 / Figma).
 * Clase `map-info-min` del DS + fondo blanco explícito (Google InfoWindow deja el chrome transparente).
 * Filas apiladas con `tec-info-group` (sin `tec-list-detail` → sin separador ·).
 */
@Component({
	selector: 'app-map-device-info',
	standalone: true,
	imports: [TranslatePipe, InfoGroupComponent, ButtonIconComponent, LinkComponent],
	encapsulation: ViewEncapsulation.None,
	template: `
		<div class="map-info-min app-map-device-info__card">
			@if (title) {
				<h6 class="map-info-min__title">{{ title }}</h6>
			}
			@if (rows?.length) {
				<div class="app-map-device-info__rows">
					@for (row of rows; track $index) {
						<tec-info-group>
							<b>{{ row.prefix }}</b>
							<span>{{ row.value || '-' }}</span>
							@if (row.lockMode === 'block') {
								<tec-button-icon
									icon="icon-lock"
									size="sm"
									[tooltip]="'BUTTON.BLOCK' | translate"
									(clickEvent)="handleBlockUnlock($event)"
								/>
							}
							@if (row.lockMode === 'unlock') {
								<tec-button-icon
									icon="icon-unlock"
									size="sm"
									[tooltip]="'BUTTON.UNBLOCK' | translate"
									(clickEvent)="handleBlockUnlock($event)"
								/>
							}
						</tec-info-group>
					}
				</div>
			}
			@if (onViewDetails) {
				<tec-link
					size="sm"
					[label]="'GENERAL.SHOW_DETAILS' | translate"
					(click)="handleViewDetails($event)"
				/>
			}
		</div>
	`,
	styleUrl: './map-device-info.component.scss',
})
export class MapDeviceInfoComponent {
	@Input() title?: string;
	@Input() rows?: IMapDeviceInfoRow[];
	/** Callback inyectado desde el marcador (`infoWindow.input`). */
	@Input() onViewDetails?: () => void;
	/** Callback bloquear/desbloquear IP (abre el modal del detalle). */
	@Input() onBlockUnlock?: () => void;

	@Output() viewDetails = new EventEmitter<void>();
	@Output() blockUnlock = new EventEmitter<void>();

	public handleViewDetails(event: Event): void {
		event.preventDefault();
		event.stopPropagation();
		this.onViewDetails?.();
		this.viewDetails.emit();
	}

	public handleBlockUnlock(event: Event): void {
		event.preventDefault();
		event.stopPropagation();
		this.onBlockUnlock?.();
		this.blockUnlock.emit();
	}
}
